export default __webpack_public_path__ + "placeholder_image.png";